export default __webpack_public_path__ + "static/media/@leilabettcher.86e78861.jpg";